const getCryptoApi = () => {
    if (typeof window !== "undefined" && window.crypto) return window.crypto;
    return null;
}

const fillFallbackRandomBytes = (bytes) => {
    const timestamp = Date.now();
    bytes.forEach((value, index) => {
        const timestampByte = index < 6
            ? Math.floor(timestamp / (256 ** index)) & 255
            : 0;
        bytes[index] = Math.floor(Math.random() * 256) ^ timestampByte;
    });
}

const formatUuidV4 = (bytes) => {
    bytes[6] = (bytes[6] & 15) | 64;
    bytes[8] = (bytes[8] & 63) | 128;

    const hexadecimal = Array.from(bytes, (byte) => (`0${byte.toString(16)}`).slice(-2)).join("");
    return [
        hexadecimal.slice(0, 8),
        hexadecimal.slice(8, 12),
        hexadecimal.slice(12, 16),
        hexadecimal.slice(16, 20),
        hexadecimal.slice(20),
    ].join("-");
}

export const generateToken = (cryptoApi = getCryptoApi()) => {
    if (typeof cryptoApi?.randomUUID === "function") {
        try {
            return cryptoApi.randomUUID.call(cryptoApi);
        } catch (error) {
            // Older Android WebViews can expose the method without supporting the invocation.
        }
    }

    const randomBytes = new Uint8Array(16);
    if (typeof cryptoApi?.getRandomValues === "function") {
        try {
            cryptoApi.getRandomValues.call(cryptoApi, randomBytes);
        } catch (error) {
            fillFallbackRandomBytes(randomBytes);
        }
    } else {
        fillFallbackRandomBytes(randomBytes);
    }

    return formatUuidV4(randomBytes);
}
